import { render } from "./PagamentoRecargaCartao.vue?vue&type=template&id=2573b12c"
import script from "./PagamentoRecargaCartao.vue?vue&type=script&lang=js"
export * from "./PagamentoRecargaCartao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__